import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetPurchaseByItemQuery } from "../../../services/Reports";
import {
  getPurchaseByItemRequest,
  getPurchaseByItemFailure,
  getPurchaseByItemSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allPurchaseByItem,
    isLoading: purchaseByItemLoading,
    isError: purchaseByItemError,
  } = useGetPurchaseByItemQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.purchaseByItemPageNo,
    pageSize: state.purchaseByItemPageSize,
    fromDate: new Date(state.purchaseByItemFromDate).toLocaleDateString(),
    toDate: new Date(state.purchaseByItemToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (purchaseByItemLoading) {
      dispatch(getPurchaseByItemRequest());
    }
    if (purchaseByItemError) {
      dispatch(getPurchaseByItemFailure(purchaseByItemError));
    }
    if (allPurchaseByItem) {
      dispatch(
        getPurchaseByItemSuccess({
          data: allPurchaseByItem.data.purchaseByItem[0].data || [],
          totalPages:
            allPurchaseByItem.data.purchaseByItem[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allPurchaseByItem,
    profileData,
    state.purchaseByItemFromDate,
    state.purchaseByItemToDate,
    state.purchaseByItemPageNo,
    state.purchaseByItemPageSize,
  ]);
  return <></>;
};
export default Content;
